import React from "react";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import Term from "../components/term";
import { useState } from "react";
import NonLoginHeader from "../components/header/NonLoginHeader";
import MobileHeader from "../components/header/MobileHeader";
import LoginMobileHeader from "../components/header/LoginMobileHeader";
import CRMobileHeader from "../components/header/CRMobileHeader";
import LoginHeader from "../components/header/LoginHeader";
import CRHeader from "../components/header/CRHeader";
import InstituteMobileHeader from "../components/header/InstituteMobileHeader";
import InstituteHeader from "../components/header/InstituteHeader";
import { Helmet } from "react-helmet";

Termsofuse.propTypes = {};

function Termsofuse(props) {
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const module = localStorage.getItem('Module')

  return (
    <>
     <Helmet>
				<title>Terms-and-Conditions | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content=" Terms-and-Conditions | Jobkikhoj" />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
   {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader  handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader  handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader  handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader  handleMobile={handleMobile} /> :
                            <NonLoginHeader  handleMobile={handleMobile} />}
            
      <div className="pt-70">
        <Term />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default Termsofuse;
